import {environment} from "../../environments/environment";
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import {Router} from '@angular/router';
import {EMPTY, Observable} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {UsuarioService} from "./usuario.service";
import {LoginService} from "./login.service";
import {isUndefined} from "util";
import {NgxSpinnerService} from "ngx-spinner";
import {MessageService} from "../core/services/message.service";

@Injectable({
	providedIn: 'root'
})

export class GovBrService {

	/*HOMOLOGAÇÃO*/
	/*private gov_br = {
		secret : 'Rc2KYhvS3bs-djztQaGcEdA_AEwg8ZiFn4DfCb1xwzYH5bm6NpqxAA5iLewllcI7-XjqZMcFY4aZSIyg58qRcQ',
		redirect_uri: 'http://planmob.hmg.cidades.gov.br/login',
		client_id: 'planmob_dev',
		response_type: 'code',
		scope: 'openid+email+phone+profile+govbr_empresa+govbr_confiabilidades',
		logout_uri: 'http://planmob.hmg.cidades.gov.br/logout',
		BASE_API_URL: 'https://sso.staging.acesso.gov.br/',
		code: '',//CÓDIGO DE AUTENTICAÇÃO GERADO PELO PROVEDOR. SERÁ UTILIZADO PARA OBTENÇÃO DO TOKEN DE RESPOSTA. POSSUI LIFETIME E SÓ PODE SER UTILIZADO UMA ÚNICA VEZ.
		ACCESS_TOKEN: null,
		ID_TOKEN: null,
		JWK_PUBLIC_KEY: null,
		state: '', //USADO NO ENVIO DA REQUISIÇÃO E NA RESPOSTA PRA CONFIRMAÇÃO DE AUTENTICIDADE.
		nonce: '',
	};*/

	/*PRODUÇÃO*/
	private gov_br = {
		secret : 'X6K1bCm6PjerHPw_xF3z_42e_1DUyDhtUjccrnsdslaqUw5okOFI2MCqyoJ-qKpqOUcqK8Q-Z92rpG7E6VCuUg',
		redirect_uri: 'https://planmob.cidades.gov.br/login',
		client_id: 'planmob.mdr.gov.br',
		response_type: 'code',
		scope: 'openid+email+phone+profile+govbr_empresa+govbr_confiabilidades',
		logout_uri: 'https://planmob.cidades.gov.br/logout',
		BASE_API_URL: 'https://sso.acesso.gov.br/',
		code: '',//CÓDIGO DE AUTENTICAÇÃO GERADO PELO PROVEDOR. SERÁ UTILIZADO PARA OBTENÇÃO DO TOKEN DE RESPOSTA. POSSUI LIFETIME E SÓ PODE SER UTILIZADO UMA ÚNICA VEZ.
		ACCESS_TOKEN: null,
		ID_TOKEN: null,
		JWK_PUBLIC_KEY: null,
		state: '', //USADO NO ENVIO DA REQUISIÇÃO E NA RESPOSTA PRA CONFIRMAÇÃO DE AUTENTICIDADE.
		nonce: '',
	};

	constructor(
		private http: HttpClient,
		private router: Router,
		private loginService: LoginService,
		private loadingService: NgxSpinnerService,
		private messageService: MessageService,
		private usuarioService: UsuarioService,) {
	}

	redirectGovBr() : void {
		this.loadingService.show();
		this.setNonce();
		this.setState();
		location.href = `${this.gov_br.BASE_API_URL}authorize?
		response_type=${this.gov_br.response_type}&
		client_id=${this.gov_br.client_id}&
		scope=${this.gov_br.scope}&
		redirect_uri=${this.gov_br.redirect_uri}&
		nonce=${this.gov_br.nonce}&
		state=${this.gov_br.state}`;
		this.loadingService.hide();
	}

	setAccessToken(access_token: any): void {
		this.gov_br.ACCESS_TOKEN = access_token;
	}

	getAccessToken(): any {
		return this.gov_br.ID_TOKEN;
	}

	getJwkPublicKey(): any {
		return this.gov_br.JWK_PUBLIC_KEY;
	}

	setIdToken(id_token: any): void {
		this.gov_br.ID_TOKEN = id_token;
	}

	getIdToken(): any {
		return this.gov_br.ID_TOKEN;
	}

	setNonce(): void {
		this.gov_br.nonce = this.toMd5(this.getRandom());
	}

	setState(): void {
		this.gov_br.state = this.toMd5(this.getRandom());
	}

	setCode(code: any) {
		this.gov_br.code = code;
	}

	getCode() {
		return this.gov_br.code;
	}

	getRandom(): any {
		return  `${Math.floor(Math.random() * (999999 - 100000)) + 100000}`;
	}

	toMd5(toEncrypt: any): any {
		return CryptoJS.MD5(`${toEncrypt}`).toString();
	}

	toBase64(toEncrypt: any) : any {
		let Utf8Encoded = CryptoJS.enc.Utf8.parse(toEncrypt);
		return CryptoJS.enc.Base64.stringify(Utf8Encoded);
	}

	HandlerconsoleReport(toBeReported: any, consoleType?: 'log' | 'warn' | 'error' | 'table'):Observable<any> {
		switch (consoleType) {
			case "table":
				console.table(toBeReported);
				break;

			case "error":
				console.error(toBeReported);
				break;

			case 'warn':
				console.warn(toBeReported);
				break;

			case 'log':
			default:
				console.log(toBeReported);
				break;
		}
		return EMPTY
	}

	authorizeInGovBr(): Observable<any> {
		this.destroyLocalItem("data");
		this.destroyLocalItem("jwk_public_key");
		this.destroyLocalItem("id_token");
		let client_secret = this.toBase64(`${this.gov_br.client_id}:${this.gov_br.secret}`);

		let headers = new HttpHeaders({
			'content-Type': 'application/x-www-form-urlencoded',
			Authorization: `Basic ${client_secret}`
		});

		let url = `${this.gov_br.BASE_API_URL}token?grant_type=authorization_code&code=${this.getCode()}&redirect_uri=${this.gov_br.redirect_uri}`;

		this.http.post<any>(url, { }, {headers: headers}).toPromise()
			.then((data) => {
				this.storeLocalItem('id_token', data.id_token);
				this.requestJwkPublicKey().subscribe();
			}).catch((error) => {
			window.location.href = "/login";
			this.HandlerconsoleReport(error.message, 'error');
		});

		return EMPTY;
	}

	requestJwkPublicKey(): Observable<any> {
		const response = this.http.get(`${this.gov_br.BASE_API_URL}jwk`).toPromise();

		response.then((data: any) => {
			this.storeLocalItem('jwk_public_key', data);
			this.decodejwk().subscribe();
		}).catch((error: any) => {
			this.HandlerconsoleReport(error.message, 'error')
		});

		return EMPTY;
	}

	decodejwk(): Observable<any> {

		const params = {
			jwk_public_key: this.getLocalItem("jwk_public_key"),
			id_token: this.getLocalItem("id_token"),
		};

		return this.http.post(`${environment.api_url}/govbr/decodejwk`, params).pipe(
			map((response: any) => {
				this.destroyLocalItem("jwk_public_key");
				this.destroyLocalItem("id_token");
				this.storeLocalItem('data', response);
				this.forwardUserByCpf(response.sub).subscribe();
			}),
			catchError((error) => {
				this.loadingService.hide();
				this.messageService.showResponseError(error.message);
				this.HandlerconsoleReport(error.message, 'error')
				return EMPTY;
			}));
	}

	storeLocalItem(key: string, data: any): any {
		localStorage.setItem(key, JSON.stringify(data));
	}

	getLocalItem(key: string): any {
		let response = false;
		if(localStorage.getItem(key)) {
			response = JSON.parse(localStorage.getItem(key));
		}
		return response;
	}

	destroyLocalItem(key: string): void {
		localStorage.removeItem(key);
	}

	//REDIRECIONA O USUÁRIO DE ACORDO COM SUA SITUAÇÃO CADASTRAL
	forwardUserByCpf(userCpf: string): Observable<any> {
		this.loadingService.show();
		this.usuarioService.findByCpf(userCpf).toPromise().then((response) => {
			if (response === undefined) {
				window.location.href = "/cadastro-externo";
			}
			else {
				this.loginService.loginUsuarioGovBr(response.num_cpf).then(() => {
					this.loadingService.hide();
					switch (response.txt_situacao) {
						case 'ativo':
							this.destroyLocalItem("data");
							window.location.href= '/login';
							break;
						case 'recusado':
							this.messageService.showInfo("Sua solicitação de cadastro foi recusada !");
							this.destroyLocalItem("data");
							break;
						case 'pendente':
							this.router.navigateByUrl('/usuario-externo');
							break;
						default:
							window.location.href = "cadastro-externo";
							break;
					}
				}).catch((error) => {
					this.loadingService.hide();
					this.HandlerconsoleReport(error.message, 'error');
					this.messageService.showResponseError(error);
				})
			}
		});
		return EMPTY;
	}

	logout(): void {
		let auth: string = this.getLocalItem("auth");
		localStorage.clear();
		let redirect: string = `https://sso.staging.acesso.gov.br/logout?post_logout_redirect_uri=${this.gov_br.logout_uri}`;
		if (auth === 'ad') {
			redirect = '/login'
		}
		location.href = redirect;
	}
}
